import {vSubscriptionTypeBase} from '../database-models/v-subscription-type-base';
//Generated Imports
import { actionColumn } from '@rxweb/grid';
@actionColumn({
    name: 'action',
    allowSorting: false,
    configuredTemplate: { templateName: 'action' }, columnIndex: 0, headerTitle: "Action", class: ["actionFild"],headerCellClass:["pl-4"]
})
export class vSubscriptionType extends vSubscriptionTypeBase 
{




//#region Generated Reference Properties

//#endregion Generated Reference Properties


































}